import clsx from 'clsx';

import { Suggestion } from './Suggestion.js';
import * as styles from './SuggestionGroup.sty.js';
import type { FilterFieldSuggestionGroupProps } from './SuggestionGroup.types.js';
import { SuggestionGroupLabel } from './SuggestionGroupLabel.js';
import { useAriaLabelingProps as _useAriaLabelingProps } from '../../../core/hooks/useAriaLabelingProps.js';
import { useSlots } from '../../../core/hooks/useSlots.js';

/**
 * @public
 */
export const SuggestionGroup = (props: FilterFieldSuggestionGroupProps) => {
  const {
    children,
    id,
    label,
    suggestions,
    className: consumerClassName,
    style: consumerStyle,
    'data-testid': dataTestId,
    ...remainingProps
  } = props;
  const ariaLabelingProps = _useAriaLabelingProps(remainingProps);

  const [slots, freeForm] = useSlots(children, { label: SuggestionGroupLabel });

  return (
    <div
      id={id}
      data-testid={dataTestId}
      role="group"
      className={clsx(styles.suggestionGroup, consumerClassName)}
      style={consumerStyle}
      {...ariaLabelingProps}
      {...remainingProps}
    >
      {slots.label}
      {slots.label === undefined && label && (
        <SuggestionGroupLabel>{label}</SuggestionGroupLabel>
      )}
      {suggestions?.map((suggestion, index) => (
        <Suggestion key={`${suggestion.value}-${index}`} {...suggestion} />
      ))}
      {freeForm}
    </div>
  );
};

SuggestionGroup.displayValue = 'FilterField.SuggestionGroup';
